/* istanbul ignore file */
const currentYPosition = () => {
    // Firefox, Chrome, Opera, Safari
    if (self.pageYOffset) return self.pageYOffset;
    // Internet Explorer 6 - standards mode
    if (document.documentElement && document.documentElement.scrollTop) {
        return document.documentElement.scrollTop;
    }
    // Internet Explorer 6, 7 and 8
    if (document.body.scrollTop) {
        return document.body.scrollTop;
    }
    return 0;
};

const elmYPosition = (elm, customOffsetTop) => {
    let y = customOffsetTop || elm.offsetTop;
    let node = elm;
    while (node.offsetParent && node.offsetParent !== document.body) {
        node = node.offsetParent;
        y += node.offsetTop;
    }
    return y;
};

const scrollTo = (leapY) => () => window.scrollTo(0, leapY);

export default (element, customOffsetTop) => {
    const startY = currentYPosition();
    const stopY = elmYPosition(element, customOffsetTop);
    const distance = stopY > startY ? stopY - startY : startY - stopY;
    if (distance < 100) {
        window.scrollTo(0, stopY);
        return;
    }
    let speed = Math.round(distance / 100);
    if (speed >= 20) {
        speed = 20;
    }
    const step = Math.round(distance / 25);
    let leapY = stopY > startY ? startY + step : startY - step;
    let timer = 0;
    if (stopY > startY) {
        for (let i = startY; i < stopY; i += step) {
            setTimeout(scrollTo(leapY), timer * speed);
            leapY += step;
            if (leapY > stopY) {
                leapY = stopY;
            }
            timer += 1;
        }
        return;
    }
    for (let i = startY; i > stopY; i -= step) {
        setTimeout(scrollTo(leapY), timer * speed);
        leapY -= step;
        if (leapY < stopY) {
            leapY = stopY;
        }
        timer += 1;
    }
};
